import { v4 as uuidv4 } from "uuid";
import { NodeDataType } from "./editorInterface";

const extractQids = (
  editorContent: Array<NodeDataType>,
  newQid: string,
  insertIndex: number
) => {
  const result = [];

  for (let i = 0; i < editorContent.length; i++) {
    const node = editorContent[i];

    if (i === insertIndex) {
      result.push(newQid);
    } else if (
      ["queryTextBox", "queryInput"].includes(node.type) &&
      node.attrs &&
      node.attrs.qid
    ) {
      result.push(node.attrs.qid);
    }
  }

  // If the insertion point is at the end, add it here
  if (insertIndex >= editorContent.length) {
    result.push(newQid);
  }

  return result;
};

const addQueryInputNode = (e: React.KeyboardEvent<HTMLDivElement>) => {
  const editor = (window as Window).fp?.editor;
  if (!editor) return;
  const { from } = editor.state.selection;
  const startOfBlock = editor.view.state.doc.resolve(from).start();

  if (from === startOfBlock) {
    e.preventDefault();

    const uniqueId = uuidv4();
    const editorContent = (editor.getJSON().content || []) as NodeDataType[];

    // Calculate the insert index at the top level
    let insertIndex = 0;
    let totalLength = 0;

    for (let i = 0; i < editorContent.length; i++) {
      const nodeLength =
        editor.view.state.doc.nodeAt(totalLength)?.nodeSize || 0;
      if (totalLength + nodeLength > from) {
        insertIndex = i;
        break;
      }
      totalLength += nodeLength;
    }

    // Extract existing qids and insert the new one at the correct position
    const qids = extractQids(editorContent, uniqueId, insertIndex);

    // create a string of the qids separated by commas
    const workspaceQids = qids.join(",");

    const htmlContent = `<query-input qid='${uniqueId}' workspaceQids='${workspaceQids}'></query-input>\n<p></p>\n<p></p>`;
    editor.chain().insertContent(htmlContent).run();
  } else {
    // do nothing
  }
};

export default addQueryInputNode;
